var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 259,
    viewBox: "0 0 62 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.297 40.0111H55.6461V176.651C55.6461 192.437 53.6086 207.309 49.5789 219.582C44.9606 234.181 35.9504 246.134 25.2196 252.567C18.8355 256.354 11.3194 258.681 1.17722 259L0 243.808C8.10468 243.215 13.0399 241.755 17.3866 239.154C24.9026 234.774 31.0151 226.015 34.7731 214.609C38.2595 203.797 40.297 190.657 40.297 176.651V40.0111ZM61.4416 12.5462C61.4416 18.979 55.3744 25.0925 48.9903 25.0925C42.6062 25.0925 36.539 18.979 36.539 12.5462C36.539 6.11344 42.6062 0 48.9903 0C55.3744 0 61.4416 6.11344 61.4416 12.5462Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerJ);
export default __webpack_public_path__ + "static/media/LOWER_J.1154fccb3eb5155a27c332930c644cf3.svg";
export { ForwardRef as ReactComponent };